import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './QuickActions.module.css';

const PaymentIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
    <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" />
  </svg>
);

const TrackIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
  </svg>
);

const ReportIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
    <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
  </svg>
);

const ReorderIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
    <path d="M12 6V2L7 7l5 5V8c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z" />
  </svg>
);

export const QuickActions: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Quick Actions</h3>
      <div className={styles.actions}>
        <button type="button" className={styles.primaryBtn} onClick={() => navigate('/customer-invoices')}>
          <PaymentIcon />
          Make Payment
        </button>
        <button type="button" className={styles.outlinedBtn} onClick={() => navigate('/live-tracking')}>
          <TrackIcon />
          Track Delivery
        </button>
        <button
          type="button"
          className={styles.outlinedBtn}
          onClick={() => navigate('/customer-orders')}
          title="Reorder items from a past order"
        >
          <ReorderIcon />
          Reorder
        </button>
        <button type="button" className={styles.outlinedBtn} onClick={() => navigate('/customer-report-issue')}>
          <ReportIcon />
          Report Issue
        </button>
      </div>
    </div>
  );
};
